import { render, staticRenderFns } from "./LazyMount.vue?vue&type=template&id=47be0873&"
import script from "./LazyMount.vue?vue&type=script&lang=ts&"
export * from "./LazyMount.vue?vue&type=script&lang=ts&"
import style0 from "./LazyMount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports